"use client";

import { usePathname } from "next/navigation";
import { createContext, useContext, useEffect, useReducer } from "react";

const PrealoderAnimationContext = createContext();

const initialState = {
  showPreloader: true,
};

const reducer = function (state, action) {
  switch (action.type) {
    case "complete":
      return { ...state, isLoading: false };

    case "show":
      return { ...state, showPreloader: true };

    case "hide":
      return { ...state, showPreloader: false };

    default:
      return { ...state };
  }
};

function PrealoaderAnimationProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { showPreloader } = state;
  const pathname = usePathname();

  useEffect(() => {
    if (pathname !== "/") onShowPreloader(false);
  }, [pathname]);

  function onShowPreloader(type = true) {
    type ? dispatch({ type: "show" }) : dispatch({ type: "hide" });
  }

  return (
    <PrealoderAnimationContext.Provider
      value={{
        showPreloader,
        onShowPreloader,
      }}
    >
      {children}
    </PrealoderAnimationContext.Provider>
  );
}

function usePreloaderAnimation() {
  const context = useContext(PrealoderAnimationContext);

  if (context === undefined)
    throw new Error("Context was used outside provider");

  return context;
}

export { usePreloaderAnimation, PrealoaderAnimationProvider };
